import { CSSResultGroup, html, LitElement, nothing, TemplateResult } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { rmaOverviewHeader } from './overview-header.style.js'
import 'components/shared/account/header.js'

initializeIconsByRole({
  'csc-rma-overview-header.heading': { name: 'undo', style: 'regular' },
  'csc-rma-overview-header.new-request': { name: 'plus', style: 'solid' },
})

const translations = {
  heading: () => t('heading', { ns: 'csc-rma-overview', default: 'My returns' }),
  newRequest: () => t('new_request', { ns: 'csc-rma-overview', default: 'New return request' }),
} as const

@customElement('csc-rma-overview-header')
export class CSCRmaOverviewHeader extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, rmaOverviewHeader]

  @property({ attribute: 'has-open-draft', type: Boolean })
  public hasOpenDraft = false

  @property({ attribute: 'draft-rma-url', type: String })
  public draftRmaUrl = ''

  override render(): TemplateResult | typeof nothing {
    if (!this.draftRmaUrl) return nothing
    return html`
      <csc-account-header hide-divider heading-icon-role="csc-rma-overview-header.heading">
        <span slot="heading">${translations.heading()}</span>
        <cse-button
          slot="top-action"
          variant="primary"
          url="${this.hasOpenDraft ? nothing : this.draftRmaUrl}"
          ?disabled="${this.hasOpenDraft}"
        >
          <cse-icon icon-role="csc-rma-overview-header.new-request" slot="prefix"></cse-icon>
          ${translations.newRequest()}
        </cse-button>
      </csc-account-header>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-rma-overview-header': CSCRmaOverviewHeader
  }
}
